<style>
html, body{
  overflow-x:hidden;
}
.header-toolbar {
  z-index:10;
}
.ios .header-toolbar.main {
  margin-top:24px !important;
}
.ios .header-offset {
  margin-top:24px !important;
}
.ios .dialog.dialog--active.dialog--fullscreen .system-bar.main {
  margin-top:24px;
}
.visible-ios-only { display: none; }
.ios .visible-ios-only {
  display:block;
}
.tiny {
  font-size: 10px;
}
.ag-input-xl {
  font-size: 32px;
}
.ag-input-xl input {
  max-height: 62px !important;
}
</style>
<template>
  <v-app
    id="app"
    :style='appStyle'
    :class='appClasses'
    class='grey lighten-4'
    v-scroll="onScroll" >
    <!-- :mini-variant.sync="mini" -->

    <bulk-actions
      v-if='globalSelectedAppointments && globalSelectedAppointments.length > 0'
      :selected-appointments='globalSelectedAppointments'
      @deselect='globalSelectedAppointments=[]' />

    <!-- <v-toolbar
      v-if='globalSelectedAppointments && globalSelectedAppointments.length > 0'
      fixed top color='blue' style="z-index:100000" >
      With {{ globalSelectedAppointments.length }} appointemnts.
      <v-spacer/>
      <v-btn flat @click='globalSelectedAppointments=[]' >clear</v-btn>
    </v-toolbar> -->

    <v-navigation-drawer
      style='z-index:11' touchless :disable-resize-watcher=true dark
      v-model='showHelp' width='450' app right >

      <v-system-bar status :class="themeColor"
        class='visible-ios-only main' v-if="appPlatform === 'ios'" >
      </v-system-bar>
      <!-- <tut @close='showHelp=false' :link='$store.getters.getTutorial' > -->
      <contextual-help
        @close='showHelp=false'
        :touch='tutToucher' >
      </contextual-help>
    </v-navigation-drawer>

    <v-navigation-drawer
      style='z-index:11'
      app enable-resize-watcher dark
      v-model='drawer'
      v-show='isLoggedIn' >

      <v-system-bar status :class="themeColor"
        class='visible-ios-only main' v-if="appPlatform === 'ios'" >
      </v-system-bar>

      <account-switcher class="mt-2"
        v-model='me' :groups='groups' @became='doLogin' >
      </account-switcher>

      <v-list class="pt-0 mt-3" dense>
        <!-- extract to component -->
        <template v-for="item in navItems" >
          <v-list-tile
            :key="`menu-${item.name}`"
            v-if='!item.meta.hidden_from_nav && !item.meta.showChildren'
            :class='item.meta.klass'
            @click='goto(item)' >
            <v-list-tile-content>
              <v-list-tile-title>
                <v-icon class='mr-2'>{{ item.meta.icon }}</v-icon> {{ item.name }}
                </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-avatar v-if='item.meta.new' >
              <v-chip dark class='v-chip--x-small' color='primary' >New</v-chip>
            </v-list-tile-avatar>
            <v-list-tile-avatar v-if='item.meta.updated' >
              <v-chip dark class='v-chip--x-small' color='warning' >Updated</v-chip>
            </v-list-tile-avatar>
          </v-list-tile>

          <v-list-group v-if='item.children && item.meta.showChildren' :key="`group-${item.name}`" >
            <!-- v1+ slot="activator -->
            <v-list-tile slot='activator' >
              <v-list-tile-content>
                <v-list-tile-title><v-icon class='mr-2' >{{ item.meta.icon }}</v-icon> {{ item.name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile class='nav child ml-3' :class="`hidden-ios-${child.meta.hidden_from_ios}`"
              v-for='(child, i) in item.children' :key='`child-${i}`'
              v-if='!child.meta.hidden_from_nav === true'
              @click.native='goto(child)' >
              <v-list-tile-content >
                <v-list-tile-title><v-icon class='mr-2' >{{ child.meta.icon }}</v-icon> {{ child.name }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-avatar v-if='child.meta.new' >
                <v-chip dark class='v-chip--x-small' color='primary' >New</v-chip>
              </v-list-tile-avatar>
              <v-list-tile-avatar v-if='child.meta.updated' >
                <v-chip dark class='v-chip--x-small' color='warning' >Updated</v-chip>
              </v-list-tile-avatar>
            </v-list-tile>

          </v-list-group>
        </template>
        <v-subheader class='overline' >
          More apps
        </v-subheader>
        <v-list-tile :href='LINKS.SETTINGS' target='_blank' >
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon class='mr-2' >settings</v-icon> Advanced settings
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-avatar ><v-icon small >open_in_new</v-icon></v-list-tile-avatar>
          <!-- <v-list-tile-avatar >
            <v-chip dark class='v-chip--x-small' color='warning' >New</v-chip>
          </v-list-tile-avatar> -->
        </v-list-tile>
        <v-list-tile :href='LINKS.DASHBOARD' target='_blank' >
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon class='mr-2' >dashboard</v-icon>
              Dashboard
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-avatar ><v-icon small >open_in_new</v-icon></v-list-tile-avatar>
          <!-- <v-list-tile-avatar >
            <v-chip dark class='v-chip--x-small' color='warning' >New</v-chip>
          </v-list-tile-avatar> -->
        </v-list-tile>
        <v-divider class='mt-4' ></v-divider>
        <v-list-tile
          @click='logout()' >
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon class='mr-2' >exit_to_app</v-icon> Logout
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
      <!-- <v-divider class='mt-5'></v-divider> -->
      <v-card-text>
        <v-btn
          :href='LINKS.INVITE' target='_blank'
          small block outline >
          Invite teammates
        </v-btn>
        <!-- v-if='guruinstaller' -->
        <v-img
          v-if='!isInstalled'
          class='mt-3 hidden-sm-and-up'
          src='/static/img/pwa.png' @click='installMobile' />

      </v-card-text>

      <version class='pa-3 white--text' ></version>
      <random-splash
        :with-accreditation='true'
        :with-description='false'
        @unpashbackground='setBackground'
        class='p-4 mt-2' ></random-splash>

    </v-navigation-drawer>

    <!--style='position:fixed;top:0px;height:25px;left:0px;right:0px;z-index: 2;'-->
    <v-system-bar
      status fixed
      v-if="appPlatform === 'ios'"
      class='header-toolbar'
      :class="themeColor">
    </v-system-bar>

    <v-toolbar dark fixed app flat
      v-show='isLoggedIn' class='header-toolbar main'
      :class="themeColor" >

      <!-- <v-btn
        @click.native='$router.back'
        v-show='$route.meta.with_back_btn' icon small >
        <v-icon>chevron_left</v-icon>
      </v-btn> -->
      <v-toolbar-side-icon @click.native.stop="drawer = !drawer">
      </v-toolbar-side-icon>
      <v-toolbar-title @click='$router.push("/")' >
        <span color='black' >Appointment</span><span style='color:black !important;' >Guru</span>
      </v-toolbar-title>
      <v-divider vertical class='hidden-xs-only' ></v-divider>

      <template v-if='$vuetify.breakpoint.smAndUp' >
        <v-tooltip bottom >
          <template v-slot:activator="{ on }">
            <v-btn to='/calendar' v-on='on' class='ml-3' icon ><v-icon >event</v-icon></v-btn>
          </template>
          <span>Calendar</span>
        </v-tooltip>

        <v-tooltip bottom >
          <template v-slot:activator="{ on }">
            <v-btn to='/appointments' v-on='on' icon ><v-icon >alarm_on</v-icon></v-btn>
          </template>
          <span>Appointments</span>
        </v-tooltip>

        <v-tooltip class='hidden-xs-only' bottom>
          <template v-slot:activator="{ on }">
            <v-btn id="global-link-clients" class='hidden-xs-only' to='/clients' v-on='on'  icon ><v-icon >people</v-icon></v-btn>
          </template>
          <span>Clients</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn id="global-link-invoices" class='hidden-xs-only' to='/invoices' v-on='on'  icon ><v-icon >post_add</v-icon></v-btn>
          </template>
          <span>Invoices</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn id="global-link-reports" class='hidden-xs-only' to='/reports' v-on='on'  icon ><v-icon >trending_up</v-icon></v-btn>
          </template>
          <span>Reports</span>
        </v-tooltip>
      </template>

      <v-spacer></v-spacer>

      <!-- <template v-if="appIsReady && isReadOnly === true" >
        <v-btn small
          href='http://localhost:8081/#/settings/team'
          color='success' :icon='$vuetify.breakpoint.xs' >
          <span v-if='$vuetify.breakpoint.smAndUp' >Re-activate</span>
          <v-icon>upgrade</v-icon>
        </v-btn>
      </template> -->

      <template v-if='appIsReady && showUpgrade' >
        <v-btn icon
          to='/get-started'
          color='info'
          id='global-guides-btn' >
          <v-icon>tour</v-icon>
        </v-btn>
        <v-btn
          :href='billingUrl' color='green' :icon='$vuetify.breakpoint.xs' >
          <span v-if='$vuetify.breakpoint.smAndUp' >Upgrade</span>
          <v-icon>upgrade</v-icon>
        </v-btn>
      </template>
      <v-btn
        v-if='true'
        icon small dark @click='showHelp=true' >
        <v-icon color='primary' dark>help</v-icon></v-btn>
      <!-- <range-picker v-show='$route.meta.with_datepicker === true' ></range-picker> -->

      <v-btn icon @click = 'showRangePicker=true' v-show='$route.meta.with_datepicker === true' >
        <v-icon>event</v-icon>
      </v-btn>

      <v-divider vertical class='mr-2 hidden-xs-only' />
      <!-- v-if='me && me.id' -->

      <v-dialog persistent
        v-model='showProfileDialog' max-width='600' >
        <v-card>
          <v-card-title class='subtitle-1 overline' >
            Update your profile picture
            <v-spacer/>
            <v-btn @click='showProfileDialog=false' icon ><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <uploader
              @uploadsuccess='getMe();showProfileDialog=false'
              title='Upload a profile picture'
              subtitle='A profile picture or square logo will be used in the AppointmentGuru app for your clients and in your own account. It will be shown as a round picture or avatar.'
              filename='profile_picture' >
              <template slot='gallery' slot-scope="props">
                <v-subheader>Examples of how this may look in various places</v-subheader>
                <v-layout v-for='(img, index) in props.images' :key="index" >
                  <v-flex>
                    <v-subheader>Avatar view</v-subheader>
                    <v-avatar ><img :src="img" /></v-avatar></v-flex>
                  <v-flex>
                    <v-subheader>Normal view</v-subheader>
                    <img :src="img" /></v-flex>
                </v-layout>
              </template>
            </uploader>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-menu open-on-hover bottom offset-y :close-on-content-click="false" >
        <template v-slot:activator="{ on }">
          <v-avatar v-on='on' slot='activator' color='white' class='black--text' >
            <v-progress-circular
              v-if='globalInitRequestLoading'
              indeterminate color='amber' width='2' />
            <template v-else >
              <img v-if='getProfilePicture(me)' :src='getProfilePicture(me)' />
              <span v-else >{{ initials(me) }}</span>
            </template>
          </v-avatar>
        </template>
        <v-list dense class='pa-0' >
          <v-subheader class='overline py-0 grey lighten-4' >Hi {{ me.first_name }}
            <!-- v-if='appIsReady && showUpgrade' -->
            <v-btn small dark label
              v-if='appIsReady && showUpgrade'
              :href='billingUrl'
              class='pa-0'
              style='font-size: 10px;height: 18px;'
              color='success'  >upgrade</v-btn>
          </v-subheader>
          <v-divider/>
          <v-list-tile @click="showProfileDialog = true" >
            <v-list-tile-content><v-list-tile-title>Update profile picture</v-list-tile-title></v-list-tile-content>
            <v-list-tile-avatar ><v-icon>face</v-icon></v-list-tile-avatar>
          </v-list-tile>
          <v-list-tile :href='LINKS.SETTINGS_SPACES' target='_blank' >
            <v-list-tile-content><v-list-tile-title>Account</v-list-tile-title></v-list-tile-content>
            <v-list-tile-avatar ><v-icon>settings</v-icon></v-list-tile-avatar>
          </v-list-tile>
          <v-list-tile :href='LINKS.SETTINGS_PROFILE' target='_blank' >
            <v-list-tile-content><v-list-tile-title>My profile</v-list-tile-title></v-list-tile-content>
            <v-list-tile-avatar ><v-icon>account_box</v-icon></v-list-tile-avatar>
          </v-list-tile>
          <v-list-tile @click='init' >
            <v-list-tile-content><v-list-tile-title>Reload settings</v-list-tile-title></v-list-tile-content>
            <v-list-tile-avatar ><v-icon>replay</v-icon></v-list-tile-avatar>
          </v-list-tile>
          <v-divider/>
          <!-- @click="logout" -->
          <v-list-tile @click="logout" >
            <v-list-tile-content><v-list-tile-title>Logout</v-list-tile-title></v-list-tile-content>
            <v-list-tile-avatar ><v-icon>logout</v-icon></v-list-tile-avatar>
          </v-list-tile>
        </v-list>
      </v-menu>

      <!-- <v-btn @click="showiframe=true" >Add</v-btn> -->
      <v-dialog fullscreen v-model="showiframe" >
        <ag-iframe v-if="showiframe" :src.sync="iframeSrc" @close="showiframe=false" />
      </v-dialog>
    </v-toolbar>

    <main>
      <v-content >
        <v-progress-linear v-show='pageLoading' :indeterminate='true' :height='3' class='flat' >
        </v-progress-linear>

        <!-- class='pa-2' -->
        <!-- :class='{zeropadd: $vuetify.breakpoint.xs}' -->
        <v-container class='zeropadd'
          grid-list-md fluid >
          <v-progress-linear
            v-show='pageLoading'
            class='flat' :indeterminate="true" :height='3' >
          </v-progress-linear>
          <read-only-block
            v-if='!globalDataLoading && isLoggedIn && isReadOnly === true' xs12 >
          </read-only-block>

          <space-invite-handler v-if='lookups.invitations && lookups.invitations.length > 0' />

          <transition name="fade" mode="out-in">
            <router-view
              v-if='isLoggedIn'
              @install='showInstallInstructions=true' />
            <login-page v-else >
            </login-page>
          </transition>
          <session v-if='isLoggedIn' @loggedin="initSession" />
          <!-- <v-btn
            @click.native.stop="openGlobalDialog(true, 'QuickCreate')"
            v-show='isLoggedIn' :fixed='true' :bottom="true" :right="true"
            :top='false' :left='false'
            v-model='showFab' fab dark class="blue" >
            <v-icon>add</v-icon>
          </v-btn> -->

          <!-- @contextmenu="openMenu" :filter="globalEventFilter" -->
          <GlobalEvents
            :filter="globalEventFilter"
            @keyup.191="launchClientSearch"
            @keydown.ctrl.w.exact="showiframe=true"
            @keydown.ctrl.a.exact="openGlobalDialog(true, 'QuickCreate')"
            @keydown.ctrl.i.exact="launchInvoiceDialog({appointments: $store.getters.activeAppointments})"
            @keydown.ctrl.t.exact="launchPaymentDialog()"
            @keydown.ctrl.n.exact="launchNewClientDialog({touch: Math.random()})" >
          </GlobalEvents>
          <v-fab-transition>
          <v-speed-dial
            :class="{ 'mb-5': $vuetify.breakpoint.xsOnly }"
            id="main-speed-dail"
            v-show='isLoggedIn'
            v-model="expandFab" bottom right fixed direction="top" >
            <v-btn
              slot="activator"
              v-model="expandFab"
              color="blue darken-2"
              dark fab >
              <v-icon>add</v-icon>
              <v-icon>close</v-icon>
            </v-btn>
            <v-tooltip :value="expandFab" left :nudge-left='20' :open-delay='1000' >
              <v-btn
                slot="activator"
                @click="openGlobalDialog(true, 'QuickCreate')"
                fab dark small color="green" >
                <v-icon>alarm_on</v-icon>
              </v-btn>
              <span>New Appointment (ctrl + a)</span>
            </v-tooltip>
            <v-tooltip :value="expandFab" left :nudge-left='20' >
              <v-btn
                @click="launchInvoiceDialog({appointments: $store.getters.activeAppointments})"
                slot='activator' fab dark small color="indigo" >
                <v-icon>content_copy</v-icon>
              </v-btn>
              <span>New Invoice (ctrl + i)</span>
            </v-tooltip>
            <v-tooltip :value="expandFab" left :nudge-left='20' >
              <v-btn fab dark small
                @click="launchPaymentDialog()"
                slot='activator' color="orange" >
                <v-icon>attach_money</v-icon>
              </v-btn>
              <span>New Payment (ctrl + t)</span>
            </v-tooltip>
            <v-tooltip :value="expandFab" left :nudge-left='20' >
              <v-btn
                @click="launchNewClientDialog({touch: Math.random()})"
                slot='activator' fab dark small color="blue" >
                <v-icon>account_circle</v-icon>
              </v-btn>
              <span>New Client (ctrl + n)</span>
            </v-tooltip>
            <v-tooltip :value="expandFab" left :nudge-left='20' >
              <v-btn
                @click="launchClientSearch"
                slot='activator' fab small color="yellow" >
                <v-icon>search</v-icon>
              </v-btn>
              <span>Search (/)</span>
            </v-tooltip>
          </v-speed-dial>
          </v-fab-transition>

        </v-container>
      </v-content>
    </main>
    <real-time-beacon ></real-time-beacon>

    <v-dialog
      v-model='showGlobalDialogSpace'
      :fullscreen="spaces.globalDialog.fullscreen" max-width='600' lazy persistent>
      <v-system-bar status
        v-if="appPlatform === 'ios'"
        :class="themeColor" >
      </v-system-bar>
      <v-toolbar dense flat dark :color='themeColor' >
        <v-toolbar-title>{{spaces.globalDialog.title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click='$store.dispatch("HIDE_SPACE", "globalDialog")' icon dark ><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card
        @keyup.esc='$store.dispatch("HIDE_SPACE", "globalDialog")'
        flat style='min-height:200px;' >
        <component
          v-if='spaces.globalDialog.visible'
          :is='spaces.globalDialog.component'
          v-bind.sync='spaces.globalDialog.options'
          v-on='spaces.globalDialog.actions'
          @success='pushGlobalEvent'
          @close='$store.dispatch("HIDE_SPACE", "globalDialog")' >
        </component>
        <!-- <v-card-actions>
          <v-btn  @click='$store.dispatch("HIDE_SPACE", "globalDialog")' flat >Done</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>

    <v-dialog lazy persistent
      v-model='showGlobalDialogSecondarySpace'
      :fullscreen="spaces.secondaryGlobalDialog.fullscreen" max-width='600' >
      <v-system-bar
        status
        v-if="appPlatform === 'ios'"
        :class="themeColor">
      </v-system-bar>
      <v-toolbar dense flat dark :color='themeColor' >
        <v-toolbar-title>{{spaces.secondaryGlobalDialog.title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click='$store.dispatch("HIDE_SPACE", "secondaryGlobalDialog")' icon dark ><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card
        @keyup.esc='$store.dispatch("HIDE_SPACE", "secondaryGlobalDialog")'
        flat style='min-height:200px;' >
        <component
          v-if="showGlobalDialogSecondarySpace"
          :is='spaces.secondaryGlobalDialog.component'
          v-bind.sync='spaces.secondaryGlobalDialog.options'
          v-on='spaces.secondaryGlobalDialog.actions'
          @close='$store.dispatch("HIDE_SPACE", "secondaryGlobalDialog")' >
        </component>

      </v-card>
    </v-dialog>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="showRangePicker" lazy width='325' >
      <v-system-bar
        status
        v-if="appPlatform === 'ios' && $vuetify.breakpoint.xsOnly"
        :class="themeColor">
      </v-system-bar>
      <v-toolbar dense dark flat :color='themeColor' class='mb-0 pb-0' >
        <v-toolbar-title>Choose a date range</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click='showRangePicker = false' icon dark>
          <v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <date-range-picker
        @keyup.esc='showRangePicker = false'
        @close='showRangePicker=false'
        v-model='activeDateRange' >
      </date-range-picker>
    </v-dialog>

    <v-dialog v-model="activeDialog" lazy fullscreen persistent>
      <v-system-bar
        status
        v-if="appPlatform === 'ios'"
        :class="themeColor">
      </v-system-bar>
      <v-toolbar dense dark flat :color='themeColor' >
        <v-toolbar-title v-if='dialogTitle' >{{dialogTitle}}</v-toolbar-title>
        <v-toolbar-title v-else >{{ appointment.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click='closeActiveDialog' >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card flat @keyup.esc='closeActiveDialog' >

        <global-dialog-container
          v-if='activeComponent && activeComponent.length > 1'
          :with-toolbar='false'
          :initial='activeComponent'
          :appointment='appointment'
          @close='closeActiveDialog' >
        </global-dialog-container>

      </v-card>
    </v-dialog>

    <v-bottom-nav app
      v-if='isLoggedIn'
      :value="$vuetify.breakpoint.xsOnly"
      class='elevation-20'
      style='border-top: 1px solid #ccc;' >
        <v-btn to='/' value="home">
          <span>Home</span>
          <v-icon>home</v-icon>
        </v-btn>

        <v-btn to='/calendar' value="calendar">
          <span>Calendar</span>
          <v-icon>today</v-icon>
        </v-btn>

        <v-btn to="/invoices" value="invoices">
          <span>Invoices</span>
          <v-icon>content_copy</v-icon>
        </v-btn>

        <v-btn to="/clients" value="clients">
          <span>Clients</span>
          <v-icon>group</v-icon>
        </v-btn>
      </v-bottom-nav>
      <v-footer app fluid class="pa-3 mt-5 hidden-xs-only" >
        <span class='hidden-xs-only' >
          <v-icon small color='red' >favorite</v-icon>
          Crafted in South Africa especially for you.</span>
        <v-spacer></v-spacer>
        <version :withReload='false' />
      </v-footer>

      <v-bottom-sheet v-model='showInstallInstructions' >
        <v-card>
          <v-card-title class='overline justify-center grey lighten-4 py-0' >
            Install on this device
            <v-spacer/>
            <v-btn @click="showInstallInstructions=false" icon small >
              <v-icon small>close</v-icon>
            </v-btn>

          </v-card-title>
          <v-divider/>
          <v-card-text>
            <center>
              <v-img
                src='/static/img/icons/apple-touch-icon-60x60.png'
                alt='AppointmentGuru'
                width='60' height='60' class='mb-3' />
            </center>
            <v-subheader class='overline pl-0 pb-0 mb-0' >Instructions</v-subheader>
            <ul class='mb-3'>
              <li>Click on the share icon <v-icon small >ios_share</v-icon></li>
              <li>Scroll and click on "add to home screen"</li>
            </ul>
            <p>
            The app icon will be added to your home screen and you can interact
            with AppointmentGuru just like you would any app that you have installed
            from the iStore or Play store
            </p>
          </v-card-text>
          <v-card-actions class='justify-center' >
            <v-icon>south</v-icon>
          </v-card-actions>
        </v-card>
      </v-bottom-sheet>

      <v-dialog v-model="mobileAppNotice" fullscreen >
        <v-card>
          <v-card-title class='subtitle-1 overline' >
            A better option for mobile
          </v-card-title>
          <v-card-text>
            We are moving our app out of the app stores.
            We are moving to a mobile web app.
            It will allow us to ship updates to our mobile app more regularly
            and provide you with a better experience on mobile.

            To install our mobile app: click the button below.

            <a href="https://app.appointmentguru.co/" target="_blank" >
              <v-img
                class='my-3 mx-3'
                src='/static/img/pwa.png' />
            </a>

            This will launch the app in your browser.
            Click on the share icon and then "add to home screen"
          </v-card-text>
          <v-card-actions class='mt-5' >
            <v-spacer/>
            <v-btn flat @click='mobileAppNotice=false' >I'll keep with this app for now</v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-dialog >
  </v-app>
</template>
<script>
import {
  LIST_APPOINTMENTS_IN_RANGE_REQ,
  LIST_CLIENTS_REQ,
  LIST_INVOICES_IN_RANGE_REQ,
  SAVE_INVOICE_REQ,
  LIST_GROUPS_REQ,
  GET_ME_REQ,
  LINKS
  // SHOW_APPOINTMENT_DIALOG,
  // SET_SPACE_VALUE
} from '@/store/constants'
import {ROUTES} from '@/router'
// import { mapState } from 'vuex'
import RequestsMixin from '@/mixins/requests'
import GlobalDialogContainer from '@/components/GlobalDialogContainer'
import RealTimeBeacon from '@/components/RealTimeBeacon'
import RandomSplash from '@/components/RandomSplash'
import Session from '@/components/auth/Session'
import Version from '@/components/Version'
import LoginPage from '@/components/pages/Login'
import DateRangePicker from '@/components/pickers/DateRangePicker'
import ReadOnlyBlock from '@/components/app/ReadOnlyBlock'
// global components:
import AppointmentQuickCreate from '@/components/appointment/Create'
import SendTemplate from '@/components/unibox/SendTemplate'
import SnapCode from '@/components/ui/SnapCode'
// import SpaceInviteHandler from '@/components/ui/SpaceInviteHandler'
import Uploader from '@/components/pages/settings/media/Uploader'
// import InvoiceFullCreate from '@/components/invoice/manage/FullCreate'
import AppointmentAction from '@/components/actions/AppointmentAction.vue'
// import InvoiceFullCreateMobile from '@/components/invoice/manage/FullCreateMobile'
// import InvoiceQuickCreate from '@/components/invoice/manage/QuickCreate'
import InvoiceQuickCreate from '@/components/invoice/manage/create/confirm.vue'
import SetClient from '@/components/appointment/SetClient'
import ShareCard from '@/components/cards/ShareCard'
// import Payment from '@/components/invoice/manage/Payment'
// import Payment from '@/components/appointment/payment'
import Payment from '@/components/appointment/actions/CreateTransaction'
// import AppointmentPay from '@/components/appointment/Pay'
import Client from '@/components/client/Create'
import ClientList from '@/components/client/ClientList'
import PatientInformationForm from '@/components/medicalaid/PatientInformationForm'
import SendInvoice from '@/components/invoice/SendInvoice'
import SendToMedicalAid from '@/components/actions/SendToMedicalAid'
import InvoiceSettings from '@/components/invoice/manage/InvoiceSettings'
// import AppointmentPicker from '@/components/pickers/AppointmentPicker'
import CloneAppointment from '@/components/appointment/actions/CloneAppointment.vue'
import AppointmentCodes from '@/components/appointment/AppointmentCodes'
import AppointmentProduct from '@/components/appointment/AppointmentProduct'
import MakeAppointmentOnline from '@/components/forms/Zoom/MakeAppointmentOnline'
import AccountSwitcher from '@/components/auth/AccountSwitcher.vue'
// import UpdateWizard from '@/components/ui/UpdateWizard'
import AppointmentTags from '@/components/appointment/Tag'
import ContextualHelp from '@/components/help'
import GlobalEvents from 'vue-global-events'
import BulkActions from '@/components/statement/BulkActions.vue'
import AgIframe from '@/components/ui/AgIframe.vue'
import * as Sentry from '@sentry/browser'
// import { ACTIVE } from '@/store/constants'
import {mapGetters} from 'vuex'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'app',
  mixins: [RequestsMixin],
  components: {
    AgIframe,
    GlobalEvents,
    BulkActions,
    ReadOnlyBlock,
    ContextualHelp,
    GlobalDialogContainer,
    Version,
    LoginPage,
    RealTimeBeacon,
    RandomSplash,
    DateRangePicker,
    Session,
    Uploader,
    AccountSwitcher,
    // InvoiceFullCreate,
    AppointmentAction,
    // InvoiceFullCreateMobile,
    InvoiceQuickCreate,
    SendToMedicalAid,
    SendTemplate,
    SetClient,
    Payment,
    SnapCode,
    ShareCard,
    Client,
    ClientList,
    PatientInformationForm,
    SendInvoice,
    InvoiceSettings,
    CloneAppointment,
    AppointmentQuickCreate,
    // AppointmentPay,
    // AppointmentPicker,
    AppointmentCodes,
    AppointmentProduct,
    AppointmentTags,
    MakeAppointmentOnline
    // UpdateWizard,
    // SpaceInviteHandler
  },
  data () {
    return {
      appIsReady: false,
      mobileAppNotice: false,
      showiframe: false,
      iframeSrc: 'https://settings.appointmentguru.co?frame=i#/wizards/invite/',
      showInstallInstructions: false,
      showBottomNav: true,
      offsetTop: 0,
      upgradeDialog: false,
      drawer: false,
      mini: true,
      showFab: false,
      showHelp: false,
      tutToucher: 1,
      expandFab: false,
      showRangePicker: false,
      showProfileDialog: false,
      navItems: ROUTES,
      right: null,
      appStyle: {},
      appClasses: [process.env.APP_STYLE],
      date: moment().format('YYYY-MM-DD'),
      activeDialog: false,
      showGlobalDialogSpace: false,
      showGlobalDialogSecondarySpace: false,
      LINKS: LINKS
    }
  },
  watch: {
    isLoggedIn () {
      if (this.isLoggedIn) {
        this.initSession()
      }
    },
    showHelp () {
      this.tutToucher++
    },
    currentPath () {
      if (this.globalSelectedAppointments && this.globalSelectedAppointments.length > 0) {
        this.globalSelectedAppointments = []
      }
    },
    meId () {
      if (this.meId) {
        if (window.plugins && window.plugins.OneSignal) {
          window.plugins.OneSignal.sendTag('practitioner.' + this.meId, 'general')
          window.plugins.OneSignal.syncHashedEmail(this.me.email)
        }
        // if (window.drift) {
        //   window.drift.identify(this.meId, {
        //     email: this.me.email,
        //     nickname: `${this.me.first_name} ${this.me.last_name}`
        //   })
        // }
        this.$ga.set('userId', this.meId)
        this.$ga.event('authentication', 'user authenticated')

        if (this.$cookies.get('referrers')) {
          let referrers = decodeURIComponent(this.$cookies.get('referrers'))
          try {
            referrers = JSON.parse(referrers)
          } catch (ex) { console.error('cookie is not json') }
          if (Array.isArray(referrers)) {
            referrers = referrers.join(',')
          }
          let url = 'https://api.appointmentguru.co/api/practitioners/' + this.meId + '/add_source/'
          // let url = 'http://localhost:8000/api/practitioners/' + this.meId + '/add_source/'
          let headers = this.$appointmentguru.headers
          let data = { sources: referrers }
          let options = { url, data, headers, method: 'post' }
          axios(options)
            .then((res) => {
              this.$cookies.remove('referrers')
            })
            .catch((res) => {
              console.log('server error')
            })
        } else {
          this.$cookies.remove('referrers')
        }
        this.appIsReady = true
        setTimeout(this.checkForUpdates, 3000)
      }
      try {
        Sentry.configureScope((scope) => {
          scope.setUser({ id: this.meId })
        })
      } catch (err) {
        console.log('something wrong with sentry')
      }
    },
    getInvoiceSettingsRequestStatus () {
      if (this.getInvoiceSettingsRequestStatus === 200) {
        let data = this.getInvoiceSettingsRequest.result.data
        if (data && data.active_version !== 1) {
          // this.launchUpdateWizard()
        }
      }
    },
    dialogVisibility () {
      this.activeDialog = this.dialogVisibility
    },
    globalDialogIsVisible () {
      this.showGlobalDialogSpace = this.globalDialogIsVisible
    },
    globalSecondaryDialogIsVisible () {
      this.showGlobalDialogSecondarySpace = this.globalSecondaryDialogIsVisible
    },
    dateRangeActivated () {
      this.showRangePicker = true
    },
    saveInvoiceRequestStatus () {
      if (this.saveInvoiceRequestStatus === 201) {
        this.loadInvoices()
      }
    }
  },
  methods: {
    initSession () {
      console.log('initing session')
      this.getMe()
      this.getAppointmentsInRange()
      this.getClients()
      this.getGroups()
      this.getLookups()
    },
    checkForUpdates () {
      // this.getInvoiceSettings()
    },
    setBackground (stylez) {
      this.appStyle = stylez
    },
    openHelp () {
      window.open('https://appointmentguru.co/help/', '_blank')
    },
    onScroll (e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
    },
    doLogin (payload) {
      this.$store.dispatch('LOGIN', payload)
    },
    installMobile () {
      if (window.guruinstaller && window.guruinstaller.prompt) {
        window.guruinstaller.prompt()
      } else {
        this.showInstallInstructions = true
      }
    },
    pushGlobalEvent (data) {
      let componentName = this.getObjectPath(this.spaces, 'globalDialog.component', null)
      if (componentName) {
        let options = { componentName, data }
        this.$store.commit('globalEvent', options)
      }
    },
    globalEventFilter (event, handler, eventName) {
      if (event.target.tagName === 'INPUT') { return false }
      if (event.target.tagName === 'TEXTAREA') { return false }
      return true
    },
    closeActiveDialog () {
      this.activeDialog = false
      setTimeout(() => {
        this.$store.dispatch('SHOW_APPOINTMENT_DIALOG', [false])
      }, 100)
    }
    //   if (event.code.toLowerCase() === 'slash') { return true }
    //   console.log(event.altKey, event.type)
    //   if (event.altKey === true && event.type === 'keydown') {
    //     let eventKeys = ['KeyA', 'KeyI', 'KeyP', 'KeyN']
    //     let val = (eventKeys.indexOf(event.code) >= 0)
    //     return val
    //   }
    //   return false
    // }
  },
  mounted () {
    // this.$store.dispatch('INIT')
    // this.mobileAppNotice = true
  },
  computed: {
    ...mapGetters([
      'settings',
      'token',
      'lookups',
      'isReadOnly',
      'isLoggedIn'
    ]),
    currentPath () {
      return this.$route.fullPath
    },
    guruinstaller () {
      return window.guruinstaller
    },
    isInstalled () {
      if (window.navigator.standalone) { return true }
      return false
    },
    activeDateRange: {
      get () {
        return this.$store.getters.activeDateRange
      },
      set (value) {
        this.$store.commit('SET_ACTIVE_DATE_RANGE', [value.from, value.to])
      }
    },
    dateRangeActivated () {
      return this.$store.state.application.activateRangePicker
    },
    version () {
      return '0.0.39'
    },
    saveInvoiceRequest () {
      return this.$store.getters.getRequestById(SAVE_INVOICE_REQ, true)
    },
    saveInvoiceRequestStatus () {
      return this.saveInvoiceRequest.status
    },
    pageLoading () {
      let globalRequests = [
        LIST_APPOINTMENTS_IN_RANGE_REQ,
        LIST_CLIENTS_REQ,
        LIST_INVOICES_IN_RANGE_REQ,
        GET_ME_REQ
      ]
      for (let reqId in globalRequests) {
        let req = this.$store.getters.getRequestById(reqId)
        if (req.loading) { return true }
      }
      return false
    },
    // isLoggedIn () {
    //   return this.token
    // },
    dialogVisibility () {
      return this.$store.state.application.activeDialog
    },
    activeComponent () {
      return this.$store.state.application.activeDialog
    },
    spaces () {
      return this.$store.state.application.spaces
    },
    globalDialogIsVisible () {
      return this.spaces.globalDialog.visible
    },
    globalSecondaryDialogIsVisible () {
      return this.spaces.secondaryGlobalDialog.visible
    },
    dialogTitle () {
      let titles = {
        'Reschedule': 'Reschedule',
        'Notes': 'Add a note',
        'Cancel': 'Cancel appointment',
        'CreateClient': 'New client',
        'InvoiceDetails': 'Add invoice details',
        'QuickCreate': 'New appointment'
      }
      let dialog = this.activeDialog
      if (dialog) {
        return titles[dialog]
      }
    },
    appointment () {
      return this.$store.state.application.activeAppointment || {}
    },
    me () {
      return this.$store.getters.me
    },
    meId () {
      return this.$store.getters.me.id
    },
    groups () {
      let req = this.$store.getters.getRequestById(LIST_GROUPS_REQ, true)
      if (req && req.result && req.result.data && req.result.data) {
        return req.result.data
      }
      return []
    },
    profilePicture () {
      if (this.me && this.me.profile) {
        if (this.me.profile.profile_picture) {
          return this.me.profile.profile_picture
        }
        if (this.me.profile.logo_picture) {
          return this.me.profile.logo_picture
        }
      }
    }
    // ...mapState(['activeDialog', 'activeDateRange'])
  }
}
</script>
<style>
/* .zeropadd {
  padding: 0px !important;
} */
@media only screen and (max-width: 599px) {
  /* override screen specific padding */
  .container.zeropadd {
    padding: 0px !important;
  }
}
.ios .container.zeropadd {
  margin-top:24px !important;
  padding: 0px !important;
}
.nav.child .list__tile {
  padding-left: 30px !important;
}
.v-chip.v-chip--x-small {
  font-size: 10px !important;
  font-weight: bolder;
  height: 16px !important;
}
.no-pad-left .v-list__tile{
  padding-left: 0px;
}
.overline {
  font-size: .625rem!important;
  font-weight: 400;
  letter-spacing: .1666666667em!important;
  line-height: 1rem;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// App.vue?9e9ad22c